/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { ventureFundsVentureFundVariantsCopyCreate } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-copy-create';
import { VentureFundsVentureFundVariantsCopyCreate$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-copy-create';
import { ventureFundsVentureFundVariantsCreate } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-create';
import { ventureFundsVentureFundVariantsCreate$FormData } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-create-form-data';
import { VentureFundsVentureFundVariantsCreate$FormData$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-create-form-data';
import { VentureFundsVentureFundVariantsCreate$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-create';
import { ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-create-x-www-form-urlencoded';
import { VentureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-create-x-www-form-urlencoded';
import { ventureFundsVentureFundVariantsDestroy } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-destroy';
import { VentureFundsVentureFundVariantsDestroy$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-destroy';
import { ventureFundsVentureFundVariantsList } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-list';
import { VentureFundsVentureFundVariantsList$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-list';
import { ventureFundsVentureFundVariantsPartialUpdate } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-partial-update';
import { ventureFundsVentureFundVariantsPartialUpdate$FormData } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-partial-update-form-data';
import { VentureFundsVentureFundVariantsPartialUpdate$FormData$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-partial-update-form-data';
import { VentureFundsVentureFundVariantsPartialUpdate$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-partial-update';
import { ventureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-partial-update-x-www-form-urlencoded';
import { VentureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-partial-update-x-www-form-urlencoded';
import { ventureFundsVentureFundVariantsUpdate } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-update';
import { ventureFundsVentureFundVariantsUpdate$FormData } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-update-form-data';
import { VentureFundsVentureFundVariantsUpdate$FormData$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-update-form-data';
import { VentureFundsVentureFundVariantsUpdate$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-update';
import { ventureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-update-x-www-form-urlencoded';
import { VentureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-variants/venture-funds-venture-fund-variants-update-x-www-form-urlencoded';
import { BackendVentureFundVariantDto } from '../models/backend-venture-fund-variant-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiVentureFundVariantsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ventureFundsVentureFundVariantsList()` */
  static readonly VentureFundsVentureFundVariantsListPath = '/api/venture_funds/venture-fund-variants/';

  /**
   * Получить варианты венчурных фондов.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundVariantsList$Response(
    params?: VentureFundsVentureFundVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendVentureFundVariantDto>>> {
    return ventureFundsVentureFundVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить варианты венчурных фондов.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundVariantsList(
    params?: VentureFundsVentureFundVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendVentureFundVariantDto>> {
    return this.ventureFundsVentureFundVariantsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendVentureFundVariantDto>>): Array<BackendVentureFundVariantDto> => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundVariantsCreate()` */
  static readonly VentureFundsVentureFundVariantsCreatePath = '/api/venture_funds/venture-fund-variants/';

  /**
   * Создать вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundVariantsCreate$Response(
    params: VentureFundsVentureFundVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundVariantsCreate(
    params: VentureFundsVentureFundVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /**
   * Создать вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /**
   * Создать вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundVariantsCreate$FormData$Response(
    params: VentureFundsVentureFundVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundVariantsCreate$FormData(
    params: VentureFundsVentureFundVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundVariantsUpdate()` */
  static readonly VentureFundsVentureFundVariantsUpdatePath = '/api/venture_funds/venture-fund-variants/{id}/';

  /**
   * Обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundVariantsUpdate$Response(
    params: VentureFundsVentureFundVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundVariantsUpdate(
    params: VentureFundsVentureFundVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /**
   * Обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /**
   * Обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundVariantsUpdate$FormData$Response(
    params: VentureFundsVentureFundVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundVariantsUpdate$FormData(
    params: VentureFundsVentureFundVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundVariantsDestroy()` */
  static readonly VentureFundsVentureFundVariantsDestroyPath = '/api/venture_funds/venture-fund-variants/{id}/';

  /**
   * удалить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundVariantsDestroy$Response(
    params: VentureFundsVentureFundVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsVentureFundVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * удалить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundVariantsDestroy(
    params: VentureFundsVentureFundVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsVentureFundVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundVariantsPartialUpdate()` */
  static readonly VentureFundsVentureFundVariantsPartialUpdatePath = '/api/venture_funds/venture-fund-variants/{id}/';

  /**
   * частично обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundVariantsPartialUpdate$Response(
    params: VentureFundsVentureFundVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * частично обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundVariantsPartialUpdate(
    params: VentureFundsVentureFundVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /**
   * частично обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * частично обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /**
   * частично обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundVariantsPartialUpdate$FormData$Response(
    params: VentureFundsVentureFundVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * частично обновить вариант венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundVariantsPartialUpdate$FormData(
    params: VentureFundsVentureFundVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundVariantsCopyCreate()` */
  static readonly VentureFundsVentureFundVariantsCopyCreatePath = '/api/venture_funds/venture-fund-variants/{id}/copy/';

  /**
   * Скопировать вариант венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundVariantsCopyCreate$Response(
    params: VentureFundsVentureFundVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
    return ventureFundsVentureFundVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Скопировать вариант венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundVariantsCopyCreate(
    params: VentureFundsVentureFundVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundVariantDto> {
    return this.ventureFundsVentureFundVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundVariantDto>): BackendVentureFundVariantDto => r.body),
    );
  }
}
